import React , {Component} from 'react';
import { Row, Col } from 'antd';
import { NavBar } from '../component/landing/navbar'
import { DemoScans } from '../component/landing/demo_scans'
import { Hero } from '../component/landing/hero'
import { Team } from '../component/landing/team'
import { Contact } from '../component/landing/contact'
import { Product } from '../component/landing/product'

import "../asset/style/morpheus.css"
import "../asset/style/landing.css"

export class LandingView extends Component {

    render(){
        return(
            <Row className="landing-parent full-widther">
                <Col span={24}>
                    <NavBar />
                    <Hero />
                    <Product />
                    <DemoScans />
                    <Team />
                    <Contact />
                </Col>
            </Row>
        )
    }
  }